import { call, select, put } from "redux-saga/effects";
import { isNumber } from '@bitComponents/utils/common';
import { actions as uiNeedsActions } from "../reducers/uiNeeds";
import getGaCookie from '@gcloud-npm/utils.common.get-ga-cookie';
import { normalizeRedirectError } from '@bitComponents/utils/adaByron';
import { megaMinderStatus } from '../minder/MegaMinder/megaMinderStatus';
import { sendRetargeting as sendRetargetingBit } from '../bitSagas/sendRetargeting';
import { actions as loaderControlActions } from '../reducers/loaderControl';
import { getGenericProductInfoSection, getR2RCancelSection, getR2RToHiredSection } from "./normalizers/genesys";
import { commonActions } from "../reducers/common";
import { STRING_KEYS } from "../localizedStrings/index";

const apisNeedsStore = (state) => state.apiNeeds;
const taggingStore = (state) => state.tagging;
const uiNeedsStore = (state) => state.uiNeeds;
const offerStore = (state) => state.offer;
const localizedStringsStore = (state) => state.localizedStrings;
const getErrorManagementStore = state => state.errorManagement;


export function* sendGenericProductInfoToGenesys(params) {
  const { co } = yield select(taggingStore);
  const flowStore = (state) => state.flow;
  const { flowJson } = yield select(flowStore);
  const { sendFailToGenesys } = flowJson;

  const { showError, normalizeHttpErrors, riskError } = params;
    
  const reduxUpdate = {
    successUpdate: params?.reduxUpdate?.successUpdate || commonActions.setSEInfo,
    errorUpdate: params?.reduxUpdate?.errorUpdate || showError,
  };

  if ((sendFailToGenesys || riskError) && !co) {
    const {
      productOfferingName,
      addressInfo,
      accountInfo,
      poshtSelected,
    } = yield select(apisNeedsStore);

    const { localizedStrings } = yield select(localizedStringsStore);

    const { pricesInfo } = yield select(uiNeedsStore);

    const { productOffering } = yield select(offerStore);


    const poInfo =
      pricesInfo?.recurringCharges?.products &&
      Array.isArray(pricesInfo.recurringCharges.products)
        ? pricesInfo.recurringCharges.products.find(
            (product) => product.productOffering.id === productOffering
          )
        : null;

    const payment = {
      accountNumber:
        accountInfo && accountInfo.customerAccountNumber
          ? accountInfo.customerAccountNumber
          : "",
      customerAccountId:
        accountInfo && accountInfo.customerAccountId
          ? accountInfo.customerAccountId
          : "",
    };

    const buyInfo = {
      productName: productOfferingName,
      productOffering,
      promotion: poInfo?.promotionId || "",
      promotionName: poInfo?.promotionName || "",
      price: isNumber(poInfo?.finalPrice) ? poInfo.finalPrice : "",
      priceRecurring : true,
      payment,
      riskError,
    };

    buyInfo.shipping = {
      address: addressInfo && addressInfo.address ? addressInfo.address : "",
      type: poshtSelected || undefined,
    };

    const genericProductInfo = getGenericProductInfoSection(buyInfo);

    const productInfo = [
      {
        "productOfferingId": productOffering,
        "productName": productOfferingName,
      }
    ];

    let campaignId = localizedStrings[STRING_KEYS.genesys.campaign];

    if(riskError){
      campaignId = localizedStrings[STRING_KEYS.genesys.riskCampaign];
    }

    const sendGenesysMessageParams = {
    reduxUpdate,
    normalizeHttpErrors,
    data: {
      campaignId,
      productInfo: productInfo,
      additionalInfoObj: genericProductInfo,
      co: null,
    }
  }

  yield call(sendGenesysMessage, sendGenesysMessageParams);

  yield put(commonActions.setGenesysOk());
  }
}

export function* sendRiskToGenesys(params){

  const { payload, showError, normalizeHttpErrors } = params;
  
  const { error } = payload;

  const reduxUpdate = {
    successUpdate: uiNeedsActions.sendRiskToGenesysSuccess,
    errorUpdate: showError,
  };

  let riskError = error;

  if (riskError) {
    riskError = riskError.replace("TCOL-VENTAS-020-", "");
  }

  const sendGenericProductInfoToGenesysParams = { reduxUpdate, normalizeHttpErrors, showError, riskError }

  yield call(sendGenericProductInfoToGenesys, sendGenericProductInfoToGenesysParams);
}


export function* sendAutoRenewalR2RInfoToGenesys(params) {
  const { co } = yield select(taggingStore);
  const flowStore = (state) => state.flow;
  const { flowJson } = yield select(flowStore);
  const { sendFailToGenesys } = flowJson;

  const { clientWithoutAvailableCredit, clientWithDebt, clientWithUnknownRisk } = yield select(uiNeedsStore);

  if (clientWithDebt || clientWithUnknownRisk || clientWithoutAvailableCredit) {
    return megaMinderStatus.KO;
  }
  const { showError, normalizeHttpErrors } = params;
  
  const reduxUpdate = {
    successUpdate: commonActions.setSEInfo,
    errorUpdate: showError,
  };

  if (sendFailToGenesys) {
    if (co) {
      return yield call(sendR2RCancellationToGenesys, { reduxUpdate, normalizeHttpErrors });
    } else {
      return yield call(sendR2RRenewalToGenesys, { reduxUpdate, normalizeHttpErrors });
    }
  }
}


export function* sendR2RCancellationToGenesys(params) {
  const { r2rToCancelInfo } = yield select(apisNeedsStore);
  const { co } = yield select(taggingStore);

  let r2rRenewal = null;

  if(r2rToCancelInfo){
    const { cancellationFee, previousDeviceName, poId, hasMobileInsurance } = r2rToCancelInfo;
    r2rRenewal = {
      cancellationFee: cancellationFee,
      productName: previousDeviceName,
      productOfferingId: poId,
      hasMobileInsurance,
    }
  }

  const additionalInfoObj = getR2RCancelSection(r2rRenewal);

  /* message = `${message}\nID PRODUCT OFFERING a cancelar: idPO R2R a cancelar`;
  message = `${message}\nNOMBRE TERMINAL a cancelar : Nombre R2R a cancelar`;
  message = `${message}\nCOSTE DE CANCELACIÓN ANTICIPADA : Precio de cancelación`;
  message = `${message}\nRESULTADO VALORACION RIESGO : Valoración riesgo`; */

  const sendGenesysMessageParams = {
    ...params,
    data: {
      campaignId: 'ret-genesys-renovaAuto',
      additionalInfoObj,
      co,
    }
  }

  yield call(sendGenesysMessage, sendGenesysMessageParams);
}


export function* sendR2RRenewalToGenesys(params) {
  const {
    r2rToCancelInfo,
    productOfferingName,
    addressInfo,
    deviceInfo,
    poshtSelected,
  } = yield select(apisNeedsStore);

  const { pricesInfo, riskCode, creditLimit } = yield select(uiNeedsStore);

  const { productOffering,  r2rType, r2rSubType } = yield select(offerStore);


  const poInfo =
    pricesInfo?.recurringCharges?.products &&
    Array.isArray(pricesInfo.recurringCharges.products)
      ? pricesInfo.recurringCharges.products.find(
          (product) => product.productOffering.id === productOffering
        )
      : null;


  const buyInfo = {
    productName: productOfferingName,
    productOffering,
    promotion: poInfo?.promotionId || "",
    promotionName: poInfo?.promotionName || "",
    price: isNumber(poInfo?.finalPrice) ? poInfo.finalPrice : "",
    priceRecurring : true,
    r2rType,
    r2rSubType,
    pvpr: deviceInfo.pvpUntaxed,
    riskCode,
    creditLimit,
  };

  if(deviceInfo){
    buyInfo.isPrePurchase = deviceInfo.isPrePurchase;
    buyInfo.color = deviceInfo.color;

    if (!productOfferingName && deviceInfo.name) {
      buyInfo.productName = deviceInfo.name;
    }
  }

  buyInfo.shipping = {
    address: addressInfo && addressInfo.address ? addressInfo.address : "",
    type: poshtSelected || undefined,
  };

  const r2rToBuyObj = getR2RToHiredSection(buyInfo);


  let r2rRenewal = null;

  if(r2rToCancelInfo){
    const { cancellationFee, previousDeviceName, poId, hasMobileInsurance } = r2rToCancelInfo;
    r2rRenewal = {
      cancellationFee: cancellationFee,
      productName: previousDeviceName,
      productOfferingId: poId,
      hasMobileInsurance,
    }
  }

  const r2rCancelObj = getR2RCancelSection(r2rRenewal);

  /* message = `${message}\nID PRODUCT OFFERING a cancelar: idPO R2R a cancelar`;
  message = `${message}\nNOMBRE TERMINAL a cancelar : Nombre R2R a cancelar`;
  message = `${message}\nCOSTE DE CANCELACIÓN ANTICIPADA : Precio de cancelación`;
  message = `${message}\nRESULTADO VALORACION RIESGO : Valoración riesgo`; */

  const additionalInfoObj = {
    ...r2rToBuyObj,
    ...r2rCancelObj,
  }

  const productInfo = [
    {
      "productOfferingId": productOffering,
      "productName": buyInfo.productName,
    }
  ];

  const sendGenesysMessageParams = {
    ...params,
    data: {
      campaignId: 'ret-genesys-renovaManual',
      productInfo: productInfo,
      additionalInfoObj,
      co: null,
    }
  }



  yield call(sendGenesysMessage, sendGenesysMessageParams);

  yield put(commonActions.setGenesysOk());
}

function* sendMsgToGenesys(params) {
  const { normalizeHttpErrors, reduxUpdate, data } = params;
  const { errorUpdate, successUpdate } = reduxUpdate;
  const { additionalInfoObj, productInfo, campaignId } = data;
  const { clientInfo } = yield select(apisNeedsStore);
  const { co } = yield select(taggingStore);

  if (clientInfo) {
    const { contactEmail, contactPhone } = clientInfo;

    const ga = getGaCookie();
    let sessionId = '';
    try {
      const sessionIdPromise = new Promise((resolve) => {
        gtag('get', 'G-J1GJWFY08P', 'session_id', resolve);
      });
      const response = yield sessionIdPromise;
      sessionId = response;
    } catch (error) {
      console.log(error);
    }

    const loginUrlComposed = normalizeRedirectError();

    const sendGenesysInfoParams = {
      normalizeHttpErrors,
      reduxUpdate: {
        errorUpdate,
        successUpdate,
      },
      logged: true,
      data: {
        contactInfo: {
          phone: contactPhone.value,
          email: contactEmail.value,
          // email: "gestionweb.canalonline@gmail.com",
        },
        campaign: {
          id: campaignId,
        },
        context: {
          url: btoa(loginUrlComposed),
        },
      },
    };

    if (productInfo) {
      sendGenesysInfoParams.data.products = [...productInfo];
    }

    if (additionalInfoObj) {
      sendGenesysInfoParams.data.additionalInfo = JSON.stringify(additionalInfoObj);
    }

    if (ga) {
      const gaInfo = {
        client_id: ga,
      };
      if (sessionId) {
        gaInfo.session_id = sessionId;
      }
      sendGenesysInfoParams.data.context.ga = JSON.stringify(gaInfo);
    }

    sendGenesysInfoParams.co = co;

    try {
      const response = yield call(sendRetargetingBit, sendGenesysInfoParams);

      if (response === null) {
        if (!co) {
          const { handledErrors } = yield select(getErrorManagementStore);
          yield put(errorUpdate(handledErrors.BUSINESS_ERRORS.AUTO_RENEWAL_FAIL));
          return null;
        } else {
          yield put(uiNeedsActions.setShowGenesysFail());
        }
      }

      return response;
    } catch (error) {
      console.log(`ERROOOOOOR: ${error}`);
      const errorResponse = megaMinderStatus.OK;
      errorResponse.errorInfo = error;

      return errorResponse;
    }
  }
  return null;
}

function* sendGenesysMessage(params) {
  yield put(loaderControlActions.setLoaderState({ loading: true }));

  const { reduxUpdate, normalizeHttpErrors, data } = params;

  yield call(sendMsgToGenesys, {
    normalizeHttpErrors,
    reduxUpdate,
    data,
  });
}
